















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import WebRoute from '@/modules/other/routes/web.route'

@Component
export default class Copyright extends Vue {
  constructor(private readonly routes: WebRoute) {
    super()
  }
}
